module.exports = __webpack_public_path__ + "img/Icon_comentarios_hover.138a280f.svg";